import { SHELL } from "../../../shell/shell.const";

const MY_ACCOUNT = 'mi-cuenta';
const MY_DOCUMENTS = 'documentos';
const MY_DOCUMENTS_HOME = '' ;
const MY_DOCUMENTS_MY_CERTIFICATES = 'mis-certificados';

export const MY_DOCUMENTS_ROUTES = {
    MY_DOCUMENTS,
    MY_DOCUMENTS_HOME,
    MY_DOCUMENTS_MY_CERTIFICATES,

    /** /mi-cuenta/documentos */
    ROUTE_MY_DOCUMENTS_HOME: `${SHELL}/${MY_ACCOUNT}/${MY_DOCUMENTS}`,
    /** /mi-cuente/documents/mis-certificados */
    ROUTE_MY_DOCUMENTS_CERTIFICATES: `${SHELL}/${MY_ACCOUNT}/${MY_DOCUMENTS}/${MY_DOCUMENTS_MY_CERTIFICATES}`,
}